module.exports = __webpack_public_path__ + "static/media/part-return-slide-3.0a43cb4f.jpg";